exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".import-issue-cards-dialog {\n  min-width: 300px; }\n  .import-issue-cards-dialog .title {\n    text-align: left;\n    padding: 0; }\n  .import-issue-cards-dialog .dropzone {\n    border: 1px solid rgba(0, 0, 0, 0.15);\n    text-align: center;\n    margin-top: 20px;\n    min-height: 100px; }\n    .import-issue-cards-dialog .dropzone p {\n      min-width: 100px;\n      max-width: 300px;\n      padding: 20px; }\n    .import-issue-cards-dialog .dropzone:hover {\n      cursor: pointer; }\n    .import-issue-cards-dialog .dropzone:focus {\n      outline: none; }\n    .import-issue-cards-dialog .dropzone.dropped {\n      border-color: #FF7800; }\n\n@media only screen and (max-width: 600px) {\n  .import-issue-cards-dialog {\n    min-width: 150px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/IssueCards/import/index.scss
// module id = 1781
// module chunks = 0